import { useState } from 'react';
import type React from 'react';

import { Translate } from '@change-corgi/core-react/i18n';

import { ActionButtonWrapper } from './ActionButtonWrapper';
import { CustomButton } from './CustomButton';
import { MobileRespondModal } from './MobileRespondModal';
import { useMobileModalContext } from './shared/useMobileModalContext';

type Props = {
	sticky: boolean;
	visible: boolean;
};

export const MobileRespondButton: React.FC<Props> = ({ sticky, visible }) => {
	const [isOpen, setIsOpen] = useState(false);

	const openModal = () => {
		setIsOpen(true);
	};

	const context = useMobileModalContext();

	return (
		<>
			{/* TODO: The ActionButtonWrapper and the CustomButton should be refactored to use the new DS components after all action panel variants have been migrated */}
			<ActionButtonWrapper visible={visible} sticky={sticky}>
				<CustomButton onClick={openModal} data-qa="mobile-respond-button">
					<Translate value="fe.components.petition_decision_maker_respond.action" />
				</CustomButton>
			</ActionButtonWrapper>
			<MobileRespondModal context={context} isOpen={isOpen} setIsOpen={setIsOpen} />
		</>
	);
};
